module.exports = __webpack_public_path__ + "img/slolution-7.176a1b5.png";